<template lang="pug">
modal#qualified-signature-not-found-plugin-modal(
  :no-footer='true'
  :title='$t("modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.title")'
  ref='modal'
  size='md'
)
  p(
    v-html='$t("modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.subtitle")'
  )
  .my-3.text-center
    .info-message__text.text-start.my-4
      p(
        v-html='$t("modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.message1")'
      )
      p {{ $t('modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.message2') }}
      p {{ $t('modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.message3') }}
      p(
        v-html='$t("modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.message4")'
      )
  .d-flex.justify-content-center.gap-3.flex-nowrap
    button.btn.btn-primary-outline.text-nowrap(
      @click='backToDownloadPlugin'
      style='border-width: 1px'
      type='button'
    ) {{ $t('modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.buttonBackDownload') }}
    button.btn.btn-primary.text-nowrap(
      @click='close'
      style='border-width: 1px'
      type='button'
    ) {{ $t('modal.qualifiedSignatureCertificatePluginModal.notFoundPlugin.button') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'QualifiedSignatureNotFoundPluginModal',
  components: {
    Icon,
    Modal,
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$refs.modal.close();
      this.$emit('closed');
    },
    backToDownloadPlugin() {
      this.$refs.modal.close();
      this.$emit('back-to-download-plugin');
    },
  },
};
</script>
<style scoped>
.info-message__text {
  font-size: 14px;
  line-height: 18px;
  color: #666;
}
</style>
